import React from "react";
import "./OurPartnersSection.css";

import partner1 from "../Assets/partners/logo-rmbg.png";
import partner2 from "../Assets/partners/luex.png";
import partner3 from "../Assets/partners/hollywood.png";
import partner5 from "../Assets/partners/myhealthcop.png";

import partner6 from "../Assets/partners/play-fair.png";
import partner7 from "../Assets/partners/sustain-bean.png";
import partner8 from "../Assets/partners/thebank.png";
import partner9 from "../Assets/partners/ithrive.png";
import partner10 from "../Assets/partners/gtco.png";
import partner11 from "../Assets/partners/impact.jpeg";
import partner12 from "../Assets/partners/bel-aqua.jpeg";

const partners = [
  partner1,
  partner2,
  partner3,
  partner11,
  partner12,
  partner6,
  partner7,
  partner8,
  partner9,
  partner10,
  partner5,
];

const OurPartnersSection = () => {
  return (
    <section className="partners-section">

      {/* HEADER */}
      <div className="partners-header">
        <h2>Our Partners & Enablers</h2>
      </div>

      {/* MARQUEE ROW 1 */}
      <div className="marquee">
        <div className="marquee-track">
          {[...partners, ...partners].map((logo, index) => (
            <div className="logo-item" key={index}>
              <img src={logo} alt={`Partner ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>

      {/* MARQUEE ROW 2 (REVERSE DIRECTION) */}
      <div className="marquee reverse">
        <div className="marquee-track">
          {[...partners, ...partners].map((logo, index) => (
            <div className="logo-item" key={index}>
              <img src={logo} alt={`Partner ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>

    </section>
  );
};

export default OurPartnersSection;